import { DatePicker, Form, FormInstance, Row } from "antd";
import { DATE_FORMAT } from "../../../../lib/constants";
import { useDisabledPastDates } from "../../../../lib/hooks/useDisabledPastDates";

type OnDateOptionProps = {
  form: FormInstance;
};

export const OnDateOption = ({ form }: OnDateOptionProps) => {
  const endConditionType = Form.useWatch("endConditionType", form);

  const disabledDate = useDisabledPastDates();

  return (
    <Row className="align-center">
      <span className="mr-4">On Date</span>
      <Form.Item label="" name="endDate" className="mb-0">
        <DatePicker
          disabled={endConditionType !== 2}
          disabledDate={disabledDate}
          format={DATE_FORMAT}
          allowClear={false}
          onClick={(e) => e.preventDefault()}
        />
      </Form.Item>
    </Row>
  );
};
